import { __require as requireBuild } from './vp-tokenized-fragment-build-index.js';

var buildExports = requireBuild();

export { buildExports as b };
//# sourceMappingURL=_virtual-index.js.map
